import React from "react";
import SignInForm from "../../components/Authentication/SignInForm";
import SignInSide from "../../components/Authentication/SignInSide";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7f8",
    opacity: 1,
    backgroundImage:
      "radial-gradient(#00875a 0.7000000000000001px, #f7f7f8 0.7000000000000001px)",
    backgroundSize: "14px 14px",
  },
}));
const SignInPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {/* <SignInForm /> */}
      <SignInSide />
    </div>
  );
};
export default SignInPage;
